import { config } from '~/config'

export function getSelfUrl() {
  return `${window.location.protocol}//${window.location.host}${config.ROUTER_PREFIX}`
}
